<template>
  <nav class="config-steps stepper">
    <div class="step-wrapper" v-for="step in steps" :key="step.name">
      <div v-if="step.disabled" @click.capture="prevent">
        <router-link
          active-class="step_active"
          class="stepper__item step"
          :class="step.disabled ? 'step_disabled' : ''"
          :to="step.route"
          :exact="step.exact"
        >
          <md-icon class="step__icon">{{ step.icon }}</md-icon>
          <div class="step__text">
            <span class="step__name">{{ step.name }}</span>
            <span class="step__descr"> {{ step.descr }} </span>
          </div>
        </router-link>
      </div>
      <router-link
        v-else
        active-class="step_active"
        class="stepper__item step"
        :class="step.disabled ? 'step_disabled' : ''"
        :to="step.route"
        :exact="step.exact"
      >
        <md-icon class="step__icon">{{ step.icon }}</md-icon>
        <div class="step__text">
          <span class="step__name">{{ step.name }}</span>
          <span class="step__descr"> {{ step.descr }} </span>
        </div>
      </router-link>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navigation',
  data() {
    return {
      steps: [
        {
          name: 'Krok 1',
          descr: 'Podajesz datę urodzenia',
          icon: 'today',
          active: true,
          disabled: false,
          exact: true,
          route: { name: 'date' },
        },
        {
          name: 'Krok 2',
          descr: 'Konfigurujesz plan',
          icon: 'extension',
          active: false,
          disabled: true,
          route: { name: 'calc' },
        },
        {
          name: 'Krok 3',
          descr: 'Podsumowanie i raport',
          icon: 'assignment',
          active: false,
          disabled: true,
          route: { name: 'summary' },
        },
      ],
    }
  },
  mounted() {
    this.setDisabled()
  },
  methods: {
    prevent: function(e) {
      e.preventDefault()
    },
    setActive() {
      this.steps = this.steps.map(step =>
        this.$router.currentRoute.name === step.route.name
          ? { ...step, active: true }
          : { ...step, active: false }
      )
    },
    setDisabled() {
      const index = this.steps.findIndex(
        step => step.route.name === this.$router.currentRoute.name
      )
      this.steps = this.steps.map(
        (step, id) =>
          index < id
            ? { ...step, disabled: true }
            : { ...step, disabled: false }
        // ? { ...step, disabled: true }
        // : { ...step, disabled: false }
      )
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from, next) {
      this.setDisabled()
    },
  },
}
</script>

<style scoped lang="scss">
.stepper {
  display: flex;
  align-items: center;
  border-radius: 4px;
  overflow: hidden;
}
.step {
  display: flex;
  align-items: center;
  position: relative;
  color: #3c4858 !important;
  padding: 13px 42px 13px 22px;
  background-color: #fff;
  margin-left: 1px;
  @media screen and (max-width: 992px) {
    padding: 13px 20px 13px 22px;
  }
  @media screen and (max-width: 486px) {
    padding-right: 10px;
  }
  @media screen and (max-width: 420px) {
    padding: 5px 9px;
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    right: -8px;
    top: 50%;
    background-color: #fff;
    transform: rotate(45deg);
    height: 14px;
    z-index: 1;
    width: 14px;
    margin-top: -7px;
    border-top: 1px solid #eee;
    border-right: 1px solid #eee;
    border-radius: 0 3px 0 0;
  }
  &_active {
    background-color: #f5841f;
    color: #fff !important;
    &::after {
      background-color: #f5841f;
    }
    .step__icon {
      color: #fff !important;
    }
  }
  &_disabled {
    color: #b1b5bc !important;
    .step__icon {
      color: #b1b5bc !important;
    }
    &:hover {
      cursor: not-allowed;
    }
  }
  &__icon {
    font-size: 32px !important;
    @media screen and (max-width: 458px) {
      font-size: 22px !important;
    }
  }
  &__text {
    display: flex;
    flex-direction: column;
    margin-left: 13px;
    @media screen and (max-width: 400px) {
      margin-left: 5px;
    }
    span {
      line-height: 1.1rem;
      @media screen and (max-width: 400px) {
        line-height: 1rem;
      }
    }
  }
  &__name {
    font-weight: 700;
    font-size: 14px;
    @media screen and (max-width: 458px) {
      font-size: 12px;
    }
    @media screen and (max-width: 400px) {
      font-size: 10px;
    }
  }
  &__descr {
    font-size: 13px;
    @media screen and (max-width: 458px) {
      font-size: 11px;
    }
    @media screen and (max-width: 400px) {
      font-size: 9px;
    }
  }
}
</style>
